import { estimateTermsRatio } from "@faire/deprecated-retailer-visitor-shared/components/OpenWithFaire/OpenWithFairePotentialCreditBar/helpers";
import { OwFCreditProgressBar } from "@faire/deprecated-retailer-visitor-shared/components/OpenWithFaire/OpenWithFairePotentialCreditBar/OwFCreditProgressBar";
import { useRetailer } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useRetailer";
import { useOpenWithFaireTerms } from "@faire/deprecated-retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireTerms";
import { formatMoney, moneyOrZero } from "@faire/web/common/money";
import { MoneyMath } from "@faire/web/common/MoneyMath";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const PotentialCreditBar: React.FC = () => {
  const { retailer } = useRetailer();
  const { offeredMaxTerms } = useOpenWithFaireTerms();

  const displayTermsRatio = estimateTermsRatio({
    numerator: retailer?.terms_limit,
    denominator: offeredMaxTerms,
  });

  const retailerTermsLimit = moneyOrZero(retailer?.terms_limit);

  if (
    MoneyMath.lessOrEqualToZero(retailerTermsLimit) ||
    displayTermsRatio === undefined
  ) {
    return null;
  }

  return (
    <>
      <Spacer height="3x" />
      <FullWidthRow>
        <OwFCreditProgressBar $progress={displayTermsRatio * 100} />
      </FullWidthRow>
      <Spacer height="1x" />
      <FullWidthRow justify="space-between">
        <Typography variant="labelSansRegular">
          <StrictLocalMsg
            id="vY+h7U"
            defaultMessage="{availableTermsMoney} available"
            description={{
              text: "Faire has a retailer's application for a payment terms increase",
              img: "https://cdn.faire.com/fastly/12fc68a6df6bdc76a912e15fbec64f7a5eba35c1f33023117a04937b9090f7ef.png",
            }}
            values={{
              availableTermsMoney: formatMoney({
                money: retailerTermsLimit,
                omitCentsIfZero: true,
              }),
            }}
          />
        </Typography>
        <Typography variant="labelSansRegular" align="end">
          <StrictLocalMsg
            id="VMJSmF"
            defaultMessage="{potentialTermsMoney} potential"
            description={{
              text: "Faire has a retailer's application for a payment terms increase",
              img: "https://cdn.faire.com/fastly/12fc68a6df6bdc76a912e15fbec64f7a5eba35c1f33023117a04937b9090f7ef.png",
            }}
            values={{
              potentialTermsMoney: formatMoney({
                money: offeredMaxTerms,
                omitCentsIfZero: true,
              }),
            }}
          />
        </Typography>
      </FullWidthRow>
    </>
  );
};

const FullWidthRow = styled(Row)`
  width: 100%;
`;
